/******************************************
JS - Overlay
******************************************/
const OVERLAY = {
  element: document.createElement('div'),
  selector: '[data-overlay]',
  active: false,
  activeContent: [],
  defaultClasses: 'overlay',
  removeCustomClassTimeout: null,

  init() {
    OVERLAY.element.setAttribute('class', OVERLAY.defaultClasses); 
    OVERLAY.element.setAttribute('data-overlay', 'inactive');
    document.body.appendChild(OVERLAY.element); // <- Append content overlay to DOM
    OVERLAY.element.addEventListener('click', OVERLAY.deactivate);
  },

  activate(customClass) {
    clearTimeout(OVERLAY.removeCustomClassTimeout);

    if ( customClass ) {
      OVERLAY.element.classList.add(customClass);
    }
    OVERLAY.status = true;
    OVERLAY.element.setAttribute('data-overlay', 'active');

  },

  deactivate() {
    for (var i = 0; i < OVERLAY.activeContent.length; i++) {
      OVERLAY.activeContent[i]();
    }
    OVERLAY.element.setAttribute('data-overlay', 'inactive');
    OVERLAY.activeContent = [];
    OVERLAY.status = false;

    OVERLAY.removeCustomClassTimeout = setTimeout(function() {
      OVERLAY.element.setAttribute('class', OVERLAY.defaultClasses); 
    }, 500);
  }
}

// jQuery(document).ready(function(){
  // Some other JS files utilise this but need access immediatley, otherwise don't work...
  // So took it out of ready function and all ok....
  OVERLAY.init();
// });




/******************************************
JS - Security Popup
******************************************/
const POPUP = {
  element: document.querySelector('[data-popup]'),
  closeBtns: null,
  selector: '[data-popup]',
  active: false,
  deactivateTimeout: null,

  init() 
  {
    if(!this.element) return; // exit if no popup
    if(Cookies.get('name')) return; // // exit if cookie found
    this.closeBtns = this.element.querySelectorAll('[data-close]'),
    this.addListeners();
    this.activate();
  },

  addListeners() {
    for(let i = 0; i < this.closeBtns.length; i++) {
      POPUP.closeBtns[i].addEventListener('click', POPUP.deactivate.bind(this));
    }
  },


  activate()
  {
    OVERLAY.activate('is-dark');
    OVERLAY.activeContent.push(POPUP.deactivate);
    this.element.setAttribute('data-state', 'active');
  },

  deactivate() {
    OVERLAY.element.setAttribute('data-overlay', 'inactive');
    POPUP.element.setAttribute('data-state', 'inactive');
    Cookies.set('name', 'value', { expires: 7 });
  }
}

jQuery(document).ready(function(){
  POPUP.init();
});
